<template>
  <!-- Add NavBar -->
  <div
      :class="{
    'loading-blur': isLoading,
      }"
      class="w-full">
    <router-view/>
    <l-loading></l-loading>
  </div>
</template>
<script>
import LLoading from "@/components/custom/loading/LLoading";
import {mapGetters} from "vuex";
export default {
  components: { LLoading },
  computed: {
    ...mapGetters(["isLoading", "activeUser"]),
  },
  watch: {
  },
  data() {
    return {
    };
  },
  methods: {
  },
  created() {
    this.$store.dispatch("checkLoginStatus");
  },
};
</script>
<style lang="scss">
</style>
